<template>
  <AtomLink :url="url" class="group flex flex-col md:flex-row md:items-start gap-6 sm:gap-8 xl:gap-12 w-full">
    <figure class="block rounded-lg overflow-hidden md:flex-1">
      <MoleculePicture class="block w-full" :image="image" />
    </figure>
    <div class="flex flex-auto md:flex-1 gap-6 lg:gap-8 xl:gap-12 flex-col items-start justify-start">
      <div class="flex flex-col gap-4 lg:gap-5 xl:gap-6">
        <h2 class="order-2 md:order-1 font-black text-xl sm:text-2xl lg:text-3xl xl:text-5xl 2xl:text-6xl leading-tight">{{ title }}</h2>
        <time class="order-1 md:order-2 leading-none sm:text-lg xl:text-2xl">{{ $d(new Date(date), 'medium-date') }}</time>
      </div>
      <p v-if="summary" class="font-black sm:text-lg xl:text-2xl 2xl:pr-56" v-html="truncate(stripTags(summary), { length: 256 })" />
      <AtomButton button-type="lid-read-more" class="pr-2">
        {{ t_('read-article') }}
        <AtomIconArrowRight :title="t_('read-article')" class="transform transition ease-in-out duration-200 ml-6 w-4 xl:ml-8 xl:w-5 group-hover:translate-x-2" />
      </AtomButton>
    </div>
  </AtomLink>
</template>

<script setup lang="ts">
import { setupTranslationPrefixer, stripTags, truncate } from '~/composables/util'

interface Props {
  date?: string
  url?: string
  image: object
  title: string
  summary?: string
}

defineProps<Props>()

const { t_ } = setupTranslationPrefixer('lid-highlight-article')
</script>
